import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const ACTIVE_BG = 'bg-secondary-subtle'
const INACTIVE_BG = 'bg-light'

const ACTIVE_TEXT = 'text-secondary'
const INACTIVE_TEXT = ''

const ProgressBar = ({ max, current, finished }) => {
  const goalRef = useRef(null)

  useEffect(() => {
    if (!goalRef.current) return;

    if (!finished) {
      const keyframes = [
        { offset: 0, transform: 'scale(1) translateX(0) rotate(0deg)' },
        { offset: 0.09, transform: 'scale(1.1) translateX(-5px) rotate(-10deg)' },
        { offset: 0.17, transform: 'scale(1.1) translateX(5px) rotate(10deg)' },
        { offset: 0.26, transform: 'scale(1.1) translateX(-5px) rotate(-10deg)' },
        { offset: 0.34, transform: 'scale(1.1) translateX(5px) rotate(10deg)' },
        { offset: 0.43, transform: 'scale(1) translateX(0) rotate(0deg)' },
        { offset: 1, transform: 'scale(1) translateX(0) rotate(0deg)' },
      ];

      const timing = {
        duration: 3500, // 1.5s animation + 2s pause
        easing: 'ease-in-out',
        iterations: Infinity,
      };

      const animation = goalRef.current.animate(keyframes, timing);

      return () => animation.cancel();
    }
  }, [finished]);

  const handleProgressBarTargetClick = (e) => {
    e.preventDefault()
    const element = document.getElementById('upsell-footer')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return <div
    className='d-flex sap-2 align-items-center mb-3'
    style={{color: 'var(--bs-secondary-bg-subtle)'}}
  >
    <i className='text-secondary bi-circle-fill' style={{fontSize: '1.25rem'}}></i>
    {max > 0 && [...Array(max).keys()].map(i => (
      <React.Fragment key={i}>
        <div
          className={`${i < current ? ACTIVE_BG : INACTIVE_BG} rounded flex-grow-1`}
          style={{height: '8px'}}
        />
        <i
          className={`${i < current ? ACTIVE_TEXT : INACTIVE_TEXT} bi-circle-fill`}
          style={{fontSize: '1.25rem'}}
        />
      </React.Fragment>
    ))}

    <div
      className={`${finished ? ACTIVE_BG : INACTIVE_BG} rounded flex-grow-1`}
      style={{height: '8px'}}
    />
    <i
      className={`${finished ? ACTIVE_TEXT : INACTIVE_TEXT} bi-gift-fill`}
      style={{fontSize: '2rem'}}
      onClick={handleProgressBarTargetClick}
      ref={goalRef}
    />
  </div>
}

ProgressBar.propTypes = {
  max: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  finished: PropTypes.bool,
}

export default ProgressBar
